<section class="main-container">
  <section class="homeContent">
    <header>
      <div class="topheader">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-lg-3 col-md-3">
              <h1 class="logo m-0 py-1"><a href="javascript:void(0)"><img src="../assets/images/scimax-cp-logo.png" alt=""
                    class="img-fluid"> </a></h1>
            </div>
          </div>
        </div>
      </div>
    </header>
    
    <div class="container-fluid page-content">
      <div class="row">
        <div class="col-lg-12">
          <figure class="home-banner mb-0">
            <img src="../assets/images/banner-img.jpg" alt="" class="img-fluid">
          </figure>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 pt-3">
          <div class="pagetitle title-large text-center fs-26 py-3">Select a Country</div>
          <p class="text-center">By selecting a country below, I acknowledge and agree that I am accessing information
            intended for healthcare providers/patient caregivers of the selected country.</p>
        </div>
        <div class="worldimg">
          <div class="row">
            <div class="col-md-3"> </div>
            <div class="col-md-8">

              <div class="row pt-5">
                <div class="col-md-6 d-flex py-2">
                  <div> <img alt="flag" src="../assets/images/united-states.png"></div>
                  <div class="country ps-3 pt-1">
                    <a href="https://demo.scimaxcp.com/US/" target="_blank"> United States</a>
                  </div>
                </div>

                <div class="col-md-6 d-flex py-2">
                  <div> <img alt="flag" src="../assets/images/japan.png"></div>
                  <div class="country ps-3 pt-1">
                    <a href="https://demo.scimaxcp.com/JP/" target="_blank">Japan</a>
                  </div>
                </div>

              </div>

            </div>
          </div>


        </div>

      </div>
    </div>
  </section>
</section>